import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"];
import React, { memo } from 'react';
import Transition from "./Transition";
const FadeTransition = /*#__PURE__*/memo(_ref => {
  let {
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Transition, otherProps, children);
});
export default FadeTransition;